import { ReactElement, createContext, useState } from "react";
import { stateType } from "../../store";
import { connect } from "react-redux";
import { cartItem, extrasCartItem } from "../../state_management/reducers/cart";
import { orderInfo, orderType } from "../../state_management/reducers/order";
import { setOrderDetails } from "../../state_management/actions";
import { orderDetailsType } from "../../state_management/actionTypes";
import { useCouponParams } from "../../AppProvider";

export const ServiceDurationContext = createContext<
  [number, (data: number) => void]
>([0, () => {}]);

const CheckOutProvider = ({
  children,
  cart,
  extras,
  orderInfo,
  orderDetails,
  setOrderDetails,
  noCouponCheck,
  directDetails,
  direct,
  pageCount
}: {
  children: ReactElement;
  cart: cartItem[];
  extras: extrasCartItem[];
  orderInfo: orderInfo;
  orderDetails: orderType;
  setOrderDetails: (data: Partial<orderType>) => void;
  noCouponCheck: boolean;
  directDetails: orderDetailsType | undefined;
  direct: boolean;
  pageCount: number;
}) => {
  const duration = (() => {
    const getDuration = (duration: number) => {
      const isNum = !isNaN(parseFloat(`${duration}`));

      return isNum ? duration : 0;
    };
    const durationArray = cart.map(
      (item) => getDuration(item.item.duration) * item.quantity
    );

    const extraDurationArray = extras.map(
      (item) => getDuration(item.item.duration) * item.quantity
    );

    const durationTotal = [...durationArray, ...extraDurationArray].reduce(
      (a, b) => a + b,
      0
    );
    return durationTotal;
  })();

  const [serviceDuration, setServiceDuration] = useState(duration);

  useCouponParams({
    cart,
    extras,
    directData: directDetails?.data,
    direct,
    inactive: noCouponCheck,
    pageCount,
    orderDetails,
    setOrderDetails
  });

  return (
    <ServiceDurationContext.Provider
      value={[serviceDuration, setServiceDuration]}
    >
      {children}
    </ServiceDurationContext.Provider>
  );
};

const mapStateToProps = (state: stateType) => ({
  pageCount: state.commonReducer.pageCount,
  cart: state.cartReducer.cart,
  extras: state.cartReducer.extras,
  orderDetails: state.orderReducer.details,
  orderDirect: state.orderReducer.direct,
  orderInfo: state.orderReducer.orderInfo,
  orderSuccess: state.orderReducer.success,
  settings: state.settingsReducer,
  addressBlacklisted: state.commonReloadReducer.addressBlacklisted,
  timeError: state.commonReloadReducer.timeError
});

const mapDispatchToProps = (dispatch: any) => ({
  setOrderDetails: (details: Partial<orderType>) => {
    dispatch(setOrderDetails(details) as any);
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(CheckOutProvider);
